import React, { useEffect, useState } from "react"

import { ButtonProps } from "../../ts/interfaces"
import { getStripeId } from "../../utils/stripejs"
import { addItemToCart } from "../../checkout/events"
import { useCheckoutState, useCheckoutDispatch } from "../../checkout/state"
import { findProduct, useProducts } from "../../hooks/useProducts"
import { Product } from "../../checkout/product"
import { useCurrentUser } from "../../hooks/useCurrentUser"
import ProSignup from "../auth/ProSignup"
import { navigate } from "gatsby"

const CartButton = (props: ButtonProps) => {
  const { quantity } = props

  const checkoutState = useCheckoutState()
  const dispatch = useCheckoutDispatch()

  if (!props.link) {
    return <div>PRODUCT NOT FOUND</div>
  }

  const { product, addToCart, additionalProduct } = props.link[0]

  const stripeId = getStripeId(product?.stripeId, product?.stripeTestId)
  const strapiProducts = useProducts()
  const strapiProduct = findProduct(strapiProducts, stripeId)

  if (strapiProduct === null || strapiProduct === undefined || !product) {
    return <div>PRODUCT NOT FOUND</div>
  }

  let additionalP: Product | undefined | null
  if (additionalProduct) {
    additionalP = findProduct(
      strapiProducts,
      getStripeId(additionalProduct.stripeId, additionalProduct.stripeTestId)
    )
  }
  const { user, fetch } = useCurrentUser({ noAutoFetch: !strapiProduct.isPro })
  const [showProSignup, setShowProSignup] = useState<boolean>(false)
  const [peningPro, setPeningPro] = useState<boolean>(false)

  useEffect(() => {
    if (user && user.hasProConfig() && peningPro && showProSignup) {
      handleClick()
      setShowProSignup(false)
    }
  }, [user])

  const handleClick = (event?: any) => {
    if (!addToCart) return

    if (strapiProduct.isPro && (!user || !user?.hasProConfig())) {
      setPeningPro(true)
      setShowProSignup(true)
      event?.preventDefault()
      console.log("HERE", event)
      return
    }

    if (props.onClick) {
      props.onClick()
    }

    addItemToCart(
      checkoutState,
      dispatch,
      quantity || 1,
      additionalP ? [strapiProduct, additionalP] : [strapiProduct], //the order is important
      strapiProducts
    )
    if (peningPro) {
      //the redirect was previously interupted
      navigate("/store/checkout")
    }
  }

  return (
    <>
      <ProSignup
        setModalOpen={setShowProSignup}
        modalOpen={showProSignup}
        onComplete={() => {
          //refetch the user
          fetch({})
        }}
      />
      <span onClick={handleClick}>{props.children}</span>
    </>
  )
}

export default CartButton
